import mixins from '@synergycms_core/less/mixins.js';

export default {
  page: {},
  section: {},
  customerForm: {},
  inputBox: {},
  labelText: {},
  inputText: {},
  textAreaBox: {
    font: "300 15px/15px 'Roboto', sans-serif",
    borderColor:'#d8d8d8 !important',
    '-webkit-appearance': 'none',
    '-webkit-box-shadow': '0 0 7px -2px rgb(0 0 0 / 50%) !important',
    '-webkit-box-sizing': 'border-box !important'
  },
  checkBox: {},
  inputCheck: {},
  phoneContainer: {},
  oblig: {},
  inputRadio: {},
  promotionCod: {},
  promoContainer: {},
  promoCodeIcon: {},
  promoCodeBox: {},
  inputPromo: {},
  insertCode: {},
  submitButtonContainer: {},
  promoCodeButton: {},
  correctCodeButton: {},
  rightCode: {},
  checksPayment: {},
  roomPreferences: {},
  roomPreferencesForm: {},
  roomHeader: {},
  roomTitle: {},
  bedIcon: {},
  roomSubTitle: {},
  roomToggle: {},
  up: {},
  searchOptionsButtonIcon: {},
  searchOptionsButtonIconOpen: {},
  down: {},
  preferences: {},
  preference: {},
  message: {},
  roomDetail: {},
  commentSection: {},
  paymentMethod: {},
  wrapperPciFrame: {
    overflow: 'hidden',
    width: '100%'
  },
  errorPCI: {},
  acceptBoxes: {},
  finalPrice: {},
  tableContainer: {},
  tableCell: {},
  buttonContainer: {},
  tableContainer2: {},
  taxesContainer: {},
  promotionCodeError: {},
  promoCodeDiscount: {},
  loadingPromoCodeSvg: {},
  title: {
  },
  noPadding: {},
  pciFrame: {
    fontSize: '20px',
    overflow: 'hidden',
    height: '100%',
    width: '100%'
  },
  summaryContainer: {},
  alertContainer: {},
  alertContent: {},
  alertTitle: {},
  alertButtonContainer: {},
  alertButton: {},
  show: {
    display: 'block'
  },
  hide: {
    display: 'none'
  },
  promotionalCode: {
    font: data => '500 20px ' + data.fontFamily1,
    marginBottom: '15px',
    display: 'block'
  },
  policiesTextToggle: {
    display: 'inline',
    cursor: 'pointer'
  },
  travelReasonContainer: {
    display: 'block',
    '@media (min-width: 801px)': {
      fontSize: '16px',
      marginTop: '11px'
    }
  },
  politicsText: {
    fontSize: '13px',
    color: data => data.mainColor
  },
  labelSupText:{
    fontSize: '16px',
    marginBottom:'5px',
    color: '#666',
    display:'block'
  },
  hotelModalStyle: {
    ...mixins.transitionAll('0.5s'),
    backgroundColor: 'rgba(0,0,0,0.5)',
    position: 'fixed',
    top: '0',
    right: '0',
    bottom: '0',
    left: '0',
    zIndex: '600',
    padding: '0',
    '& $availModalcontent': {
      position: 'absolute',
      top: '0',
      right: '0',
      left: '0',
      bottom: '0',
      overflow: 'auto',
      background: '#fff',
      '& $closeButton': {
        color: data => data.mainColor,
        position: 'fixed',
        right: '15px',
        top: '15px',
        border: '0',
        fontSize: '15px',
        background: 'none',
        zIndex: '1',
        '&:lang(ar)': {
          right: 'auto',
          left: '15px'
        },
      },
      '& $headerModal': {
        padding: '15px 40px 14px 20px',
        border: '1px solid #d8d8d8',
        textAlign: 'left',
        position: 'sticky',
        top: '0',
        background: '#fff',
        borderRight: 'none',
        '& $modalTitle': {
          font: data => '18px ' + data.fontFamily2,
          '@media (min-width: 801px)': {
            fontSize: '24px'
          }
        },
        '@media (min-width: 801px)': {
          padding: '25px 54px 25px 30px'
        },
        '&:lang(ar)': {
          textAlign: 'right',
          paddingLeft: '40px',
          paddingRight: '20px',
          '@media (min-width: 801px)': {
            paddingRight: '30px',
            paddingLeft: '54px'
          }
        },
      },
      '& $modalTabsList': {
        height: 'inherit',
        '& $titleListBlock': {
          padding: '19px 20px 22px',
          textAlign: 'left',
          '@media (min-width: 801px)': {
            padding: '25px 30px'
          },
          '&:lang(ar)': {
            textAlign: 'right'
          },
        }
      },
      '@media (min-width: 801px)': {
        ...mixins.transitionAll('0.5s'),
        right: '0',
        width: '600px',
        left: 'auto'
      },
      '&:lang(ar)': {
        '@media (min-width: 801px), print': {
          left: 0,
          right: 'auto'
        }
      },
    }
  },
  availModalcontent: {},
  closeButton: {},
  headerModal: {},
  modalTitle: {},
  modalTabsList: {},
  titleListBlock: {},
  totalPrice:{
    font: data => '18px ' + data.fontFamily1,
    color:'#000'
  },
  boxContainer:{
    paddingBottom:'30px'
  },
  borderedBox:{
    paddingBottom:'30px',
    borderBottom:'1px solid #d8d8d8',
    marginBottom:'30px',
    '@media (min-width: 901px)': {
      borderBottom:'1px solid #d8d8d8',
    }
  },
  radioButtonContainer:{
    '& > span':{
      display:'block',
      '&:not(:last-of-type)':{
        marginBottom:'20px',
      }
    }
  },
  radioButtonElement:{
    color:'#666',
    fontSize:'16px',
  },
  lastBox:{
    paddingTop:'15px',
    paddingBottom:'0',
    borderTop:'1px solid #d8d8d8',
  },
  first:{
    '@media (min-width: 901px)': {
      paddingRight:'20px'
    }
  },
  bonoText:{
    font: data => '300 13px ' + data.fontFamily1,
    color: '#666',
    marginBottom:'5px',
    display:'block'
  },
  giftVoucherContent:{
    '&:not(:last-of-type)':{
      marginBottom:'10px'
    }
  },
  defaultStyle: {
    margin: '0 auto',
    '&:lang(ar)': {
      direction: 'rtl'
    },
    '& $page': {
      maxWidth: '1190px',
      margin: '0 auto',
      minHeight: '100vh',
      overflow: 'hidden',
      padding: '20px 10px 40px',
      '& $section': {
        font: data => '300 11px ' + data.fontFamily1,
        width: '100%',
        background: '#fff',
        textAlign: 'left',
        '&:lang(ar)': {
          textAlign: 'right',
          '@media (min-width: 901px), print': {
            float: 'right'
          }
        },
        '& $customerForm': {
          '& > div': {
            padding: '0 0 15px',
            borderBottom: '1px solid #d8d8d8',
          },
          '& $inputBox': {
            position: 'relative',
            display: 'block',
            marginBottom: '15px',
            paddingLeft: '0',
            '&:before': {
              content: 'none'
            },
            '& $labelText': {
              position: 'absolute',
              top: '14px',
              left: '15px',
              zIndex: '0',
              color: '#8d8d8d',
              right: '10px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              ...mixins.transition('top 0.3s'),
              '@media (min-width: 901px)': {
                top: '18px',
                fontSize: '13px'
              },
              '&:lang(ar)': {
                left: 'auto',
                right: '15px',
                '@media (min-width: 901px), print': {
                  float: 'right'
                }
              },
            },
            '& $inputText': {
              font: data => '300 13px ' + data.fontFamily1,
              '&:not([value=""]) ~ $labelText': {
                top: '6px'
              },
              '@media (min-width: 901px)': {
                height: '50px',
                fontSize: '16px'
              }
            },
            '@media (min-width: 901px)': {
              width: 'calc(50% - 16px)',
              display:'inline-block',
              verticalAlign:'top',
              '&:nth-of-type(odd)':{
                marginRight:'30px'
              }
            },
            '&$textAreaBox': {
              width: '100%',
              margin: '10px 0 5px',
              '& $labelText': {
                top: '13px'
              }
            },
          },
          '& $inputText:focus': {
            '& ~ $labelText': {
              top: '6px'
            }
          },
          '& $checkBox': {
            display: 'block',
            position: 'relative',
            paddingLeft: '29px',
            '&:before': {
              content: 'none'
            },
            '&:not(:last-of-type)': {
              marginBottom: '15px'
            },
            '& > span': {
              fontSize: '13px'
            },
            '& $inputCheck': {
              position: 'absolute',
              top: '0',
              left: '0',
              '&:lang(ar)': {
                left: 'auto',
                right: 0
              },
            },
            '&$oblig': {
              paddingRight: '30px',
              '&:lang(ar)': {
                paddingLeft: '30px'
              },
            },
            '&:lang(ar)': {
              paddingRight: '29px',
              paddingLeft: 0
            },
          },
          '& $phoneContainer': {
            '& $inputBox': {
              display: 'inline-block',
              width: 'calc(100% - 97px)',
              verticalAlign: 'top',
              float: 'none',
              marginBottom: '9px',
              marginRight: '0 !important'
            },
            '@media (min-width: 901px)': {
              clear: 'both',
              width: "calc(50% - 15px)"
            }
          },
          '& $inputRadio': {
            paddingTop: '10px',
            '@media (min-width: 801px)': {
              paddingTop: '12px'
            }
          },
          '& $promotionCod': {
            padding: '15px 15px 20px',
            borderBottom: '1px solid #d8d8d8',
            width: '100%',
            overflow: 'hidden',
            '& $promoContainer': {
              position: 'relative',
              textAlign: 'right',
              border: '1px solid #ddd',
              ...mixins.boxShadow('0 0 2px -1px fade(#000, 50%)'),
              '& $promoCodeIcon': {
                color: data => data.mainColor,
                font: "24px/1px 'Icons'",
                position: 'absolute',
                left: '11px',
                top: '20px',
                '@media (min-width: 801px)': {
                  top: '24px'
                },
                '&:lang(ar)': {
                  left: 'auto',
                  right: '11px'
                },
              },
              '& $promoCodeBox': {
                textAlign: 'left',
                display: 'table',
                paddingLeft: '44px',
                height: '40px',
                width: '100%',
                ...mixins.boxSizing(),
                '& $inputPromo': {
                  font: data => '300 13px ' + data.fontFamily1,
                  ...mixins.boxSizing(),
                  display: 'table-cell',
                  verticalAlign: 'middle',
                  color: '#000',
                  background: 'transparent',
                  outline: '0',
                  height: '40px',
                  width: '100%',
                  border: 'none',
                  paddingRight: '10px',
                  '&:focus': {
                    '& ~ $insertCode': {
                      display: 'none'
                    },
                    '& ~ $submitButtonContainer': {
                      '& $promoCodeButton': {
                        display: 'block'
                      }
                    }
                  },
                  '&:not([value=""])': {
                    '& ~ $insertCode': {
                      display: 'none'
                    },
                    '& ~ $submitButtonContainer': {
                      '& $promoCodeButton': {
                        display: 'block'
                      }
                    }
                  },
                  '@media (min-width: 801px)': {
                    fontSize: '16px',
                    height: '50px'
                  },
                  '&:lang(ar)': {
                    paddingRight: '0',
                    paddingLeft: '10px'
                  },
                },
                '& $insertCode': {
                  font: data => '300 13px ' + data.fontFamily1,
                  ...mixins.transitionAll(),
                  position: 'absolute',
                  top: '12px',
                  left: '44px',
                  right: '30px',
                  color: '#000',
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  '@media (min-width: 801px)': {
                    top: '17px'
                  },
                  '&:lang(ar)': {
                    left: '30px',
                    right: '44px'
                  },
                },
                '& $submitButtonContainer': {
                  ...mixins.boxSizing(),
                  display: 'table-cell',
                  verticalAlign: 'middle',
                  width: 'auto',
                  '@media (min-width: 801px)': {
                    paddingRight: '5px'
                  },
                  '&:lang(ar)': {
                    '@media (min-width: 801px), print': {
                      paddingLeft: '5px',
                      paddingRight: '0'
                    }
                  },
                },
                '@media (min-width: 801px)': {
                  height: '50px'
                },
                '&:lang(ar)': {
                  textAlign: 'right',
                  paddingRight: '44px',
                  paddingLeft: 0
                },
              },
              '& $promoCodeButton': {
                display: 'none',
                verticalAlign: 'top',
                height: '40px',
                width: '90px',
                cursor: 'pointer',
                position: 'relative',
                zIndex: '3',
                textTransform: 'uppercase',
                fontSize: '13px',
                float: 'right',
                padding: '3px',
                overflow: 'hidden',
                '@media (min-width: 901px)': {
                  height: '40px'
                },
                '@media (min-width: 801px)': {
                  width: '120px'
                },
                '&:lang(ar)': {
                  float: 'left'
                },
              },
              '& $inputBox': {
                marginBottom: 0
              },
              '& $rightCode': {
                position: 'absolute',
                left: '0',
                bottom: '-18px',
                '&:lang(ar)': {
                  left: 'auto',
                  right: '0'
                },
              },
              '@media (min-width: 801px)': {
                display: 'inline-block',
                verticalAlign: 'middle',
                width: '345px'
              },
              '&:lang(ar)': {
                textAlign: 'left'
              },
            },
            '@media (min-width: 801px)': {
              padding: '25px 30px 30px'
            }
          },
          '& $checksPayment': {
            paddingTop: '20px',
            background: '#fff',
            borderTop: '1px solid #d8d8d8',
            '& $checkBox': {
              position: 'relative',
              display: 'block',
              paddingLeft: '29px',
              '& $inputCheck': {
                content: "''",
                position: 'absolute',
                left: '0',
                top: '0',
                width: '16px',
                height: '16px',
                border: '1px solid #ddd',
                '&:lang(ar)': {
                  left: 'auto',
                  right: 0
                },
              },
              '& span': {
                font: data => '300 13px/1.38 ' + data.fontFamily1
              },
              '&:last-of-type': {
                '@media (min-width: 901px)': {
                  marginBottom: '0'
                }
              },
              '&:lang(ar)': {
                paddingLeft: 0,
                paddingRight: '29px'
              },
            },
            '@media (min-width: 901px)': {
              padding: '20px 30px'
            }
          },
          '& $roomPreferences': {
            font: data => '500 16px ' + data.fontFamily1,
            backgroundColor: '#fff',
            color: '#000',
            textAlign: 'left',
            padding: '11px 15px 0',
            width: '100%',
            borderBottom: 'none',
            '& $roomPreferencesForm': {
              backgroundColor: '#ebebeb'
            },
            '& $roomDetail': {
              borderBottom: '1px solid #999',
              background: '#ebebeb',
              '&:last-child': {
                borderBottom: 'none'
              },
              '& $roomHeader': {
                width: '100%',
                textAlign: 'left',
                padding: '10px 19px 10px 10px',
                fontSize: '13px',
                fontWeight: 'normal',
                position: 'relative',
                '& $roomTitle': {
                  position: 'relative',
                  '& > span': {
                    display: 'block',
                    paddingLeft: '32px',
                    fontWeight: '500',
                    position: 'relative',
                    fontSize: '16px',
                    '&:lang(ar)': {
                      paddingRight: '32px',
                      paddingLeft: 0
                    },
                  },
                  '& $bedIcon': {
                    color: data => data.mainColor,
                    fontSize: '24px',
                    left: '0',
                    top: '50%',
                    position: 'absolute',
                    paddingLeft: '0',
                    marginTop: '-17px',
                    '@media (min-width: 801px)': {
                      fontSize: '32px',
                      marginTop: '-22px'
                    },
                    '&:lang(ar)': {
                      left: 'auto',
                      right: 0,
                      paddingRight: 0
                    },
                  },
                  '& span': {
                    '@media (min-width: 801px)': {
                      fontSize: '24px',
                      paddingLeft: '43px',
                      fontWeight: '300'
                    },
                    '&:lang(ar)': {
                      '@media (min-width: 801px), print': {
                        paddingLeft: 0,
                        paddingRight: '43px'
                      }
                    },
                  },
                  '&:after': {
                    fontSize: '32px'
                  }
                },
                '& $roomSubTitle': {
                  margin: '4px 0',
                  paddingRight: '15px',
                  '& span': {
                    '@media (min-width: 801px)': {
                      fontWeight: 'bold',
                      fontSize: '18px'
                    }
                  },
                  '&:lang(ar)': {
                    paddingLeft: '15px',
                    paddingRight: 0
                  },
                },
                '& $roomToggle': {
                  position: 'absolute',
                  top: 'calc(50% - 7px)',
                  right: '10px',
                  height: '15px',
                  width: '16px',
                  '&$up': {
                    '& $searchOptionsButtonIcon': {
                      font: data => '13px/1px ' + data.fontFamily1,
                      color: data => data.mainColor,
                      right: '10%',
                      top: '50%',
                      position: 'absolute',
                      display: 'block',
                      '&:lang(ar)': {
                        right: 'auto',
                        left: '10%'
                      },
                    },
                    '& $searchOptionsButtonIconOpen': {
                      display: 'none'
                    }
                  },
                  '&$down': {
                    '& $searchOptionsButtonIconOpen': {
                      font: data => '13px/1px ' + data.fontFamily1,
                      color: data => data.mainColor,
                      content: "'e052'",
                      right: '10%',
                      top: '50%',
                      position: 'absolute',
                      display: 'block',
                      '&:lang(ar)': {
                        left: '10%',
                        right: 'auto'
                      },
                    },
                    '& $searchOptionsButtonIcon': {
                      display: 'none'
                    }
                  },
                  '&:lang(ar)': {
                    left: '10px',
                    right: 'auto'
                  },
                },
                '@media (min-width: 801px)': {
                  padding: '20px 25px 20px 0'
                },
                '&:lang(ar)': {
                  textAlign: 'right',
                  paddingLeft: '19px',
                  paddingRight: '10px',
                  '@media (min-width: 801px), print': {
                    paddingLeft: '25px',
                    paddingRight: '0'
                  }
                },
              },
              '& $preferences': {
                padding: '0 10px 10px 10px',
                '& $preference': {
                  ...mixins.boxShadow('0 0 2px -1px rgba(0,0,0,0.5)'),
                  ...mixins.boxSizing(),
                  marginBottom: '10px',
                  border: '1px solid #ddd',
                  width: '100%',
                  '&:nth-of-type(odd)': {
                    '@media (min-width: 801px)': {
                      marginRight: '25px'
                    },
                    '&:lang(ar)': {
                      '@media (min-width: 801px), print': {
                        marginLeft: '25px',
                        marginRight: 0
                      }
                    },
                  },
                  '@media (min-width: 801px)': {
                    width: 'calc(50% - 15px)',
                    display: 'inline-block',
                    verticalAlign: 'top'
                  }
                },
                '& > :nth-last-child(2)': {
                  marginBottom: '0'
                },
                '@media (min-width: 801px)': {
                  padding: ' 0 0 20px'
                }
              },
              '& $message': {
                display: 'none',
                '@media (min-width: 801px)': {
                  display: 'block',
                  marginTop: '16px',
                  color: '#666',
                  fontSize: '13px',
                  lineHeight: '1.38',
                  fontWeight: '300'
                }
              },
              '@media (min-width: 801px)': {
                padding: '0 30px'
              }
            },
            '@media (min-width: 801px)': {
              padding: '0'
            },
            '&:lang(ar)': {
              textAlign: 'right'
            },
          },
          '& $commentSection': {
            overflow: 'hidden'
          },
          '& $paymentMethod': {
            font: data => '500 16px ' + data.fontFamily1,
            background: '#fff',
            padding: '15px 15px 10px',
            borderBottom: 'none',
            textAlign: 'left',
            position: 'relative',
            '@media (min-width: 901px)': {
              padding: '20px 30px 20px'
            },
            '&:lang(ar)': {
              textAlign: 'right'
            },
          },
          '& $wrapperPciFrame': {
            padding: 0,
            '@media (min-width: 901px)': {
              padding: '0 15px'
            }
          },
          '& $errorPCI': {
            background: '#fae0e0'
          },
          '& $acceptBoxes': {
            clear: 'both',
            paddingTop: '25px',
            '& $checkBox': {
              '& $inputCheck': {
                '@media (min-width: 901px)': {
                  top: '3px'
                }
              },
              '& > span': {
                '@media (min-width: 901px)': {
                  fontSize: '13px'
                }
              },
              '@media (min-width: 901px)': {
                lineHeight: '19px'
              }
            },
            '@media (min-width: 901px)': {
              padding: '20px 30px'
            }
          },
          '& $finalPrice': {
            font: data => '11px ' + data.fontFamily1,
            padding: '15px 0 0',
            background: '#fff',
            borderBottom: 'none',
            '& $tableContainer': {
              display: 'table',
              width: '100%',
              captionSide: 'bottom',
              '& $tableCell': {
                display: 'table-cell',
                verticalAlign: 'bottom',
                '&:first-of-type': {
                  '& > span:first-of-type': {
                    paddingBottom: '5px'
                  }
                },
                '&:nth-of-type(2)': {
                  textAlign: 'right',
                  '&:lang(ar)': {
                    textAlign: 'left'
                  },
                }
              },
              '& > span': {
                display: 'block',
                textAlign: 'right',
                fontSize: '14px',
                color: '#333'
              }
            },
            '& $buttonContainer': {
              paddingTop: '15px',
              display: 'table-caption',
              '& > button': {
                width: '100%',
                position: 'relative',
                padding: '0 25px 0 20px',
                '@media (min-width: 901px)': {
                  height: '50px'
                }
              },
              '@media (min-width: 901px)': {
                display: 'table-cell',
                padding: '0 0 0 30px',
                width: '215px',
                verticalAlign: 'middle'
              },
              '&:lang(ar)': {
                '@media (min-width: 801px), print': {
                  paddingLeft: '0',
                  paddingRight: '30px'
                }
              },
            },
            '@media (min-width: 901px)': {
              padding: '20px 0 20px',
              borderBottom: '1px solid #d8d8d8'
            }
          },
          '& $taxesContainer': {
            ...mixins.boxShadow('0 2px 4px 0 rgba(0,0,0,0.07)'),
            marginTop: '15px',
            padding: '0 20px 30px',
            background: '#fff',
            '@media (min-width: 901px)': {
              marginTop: '10px',
              paddingBottom: '25px',
              '& > span': {
                fontSize: '13px'
              }
            }
          },
          '& $promotionCodeError': {
            margin: '7px 0',
            borderColor: '#d0021b',
            color: '#d0021b',
            display: 'block',
            left: '0',
            position: 'absolute',
            '&:lang(ar)': {
              left: 'auto',
              right: 0
            },
          },
          '& $loadingPromoCodeSvg': {
            fill: data => data.mainColor,
            height: '30px',
            backgroundSize: 'contain',
            background: 'no-repeat center',
            animation: 'rotateInfinite 2s infinite linear',
            display:'inline-block',
            verticalAlign:'middle',
            '& .cls-1': { opacity: 0.2 },
            '& .cls-2': { opacity: 0.8 },
            '& .cls-3': { opacity: 0.1 },
            '& .cls-4': { opacity: 0.7 },
            '& .cls-5': { opacity: 0.05 },
            '& .cls-6': { opacity: 0.6 },
            '& .cls-7': { opacity: 0.03 },
            '& .cls-8': { opacity: 0.5 },
            '& .cls-10': { opacity: 0.4 },
            '& .cls-11': { opacity: 0.9 },
            '& .cls-12': { opacity: 0.3 }
          },
          '& $promoCodeDiscount': {
            marginTop: '10px',
            color: data => data.secondColor,
            paddingLeft: '5px',
            '&:lang(ar)': {
              paddingLeft: 0,
              paddingRight: '5px'
            },
          }
        },
        '@media (min-width: 901px)': {
          float: 'left',
          width: '64%',
          padding: 0
        }
      },
      '@media (min-width: 901px)': {
        padding: '20px 30px 40px',
      }
    },
    '& $title': {
      fontSize: '16px',
      fontWeight: '500',
      marginBottom: '10px',
      padding: '10px 15px 15px 0',
      display: 'block',
      '&$noPadding': {
        margin: '0 0 10px',
        padding: '0',
        display: 'block',
        '@media (min-width: 901px)': {
          padding: 0,
          marginBottom: '15px'
        }
      },
      '@media (min-width: 901px)': {
        fontSize: '20px',
        fontWeight: '500',
        margin: '0 0 6px 0',
        paddingTop: '0',
        display: 'block'
      },
      '&:lang(ar)': {
        '@media (min-width: 901px), print': {
          marginLeft: 0,
          marginRight: '10px'
        }
      },
    },
    '& $summaryContainer': {
      ...mixins.boxSizing('content-box !important'),
      display: 'block',
      float: 'right',
      width: '31%',
      padding: '0 10px',
      '& > div': {
        position: 'fixed',
        left: '0px',
        top: '0',
        right: '0',
        bottom: '0',
        overflow: 'auto',
        background: '#fff',
        display: 'none',
        zIndex: '200',
        '@media (min-width: 901px), print': {
          position: 'static',
          display: 'block !important'
        }
      },
      '@media (max-width: 900px)': {
        position: 'fixed',
        top: '0',
        right: '100%',
        zIndex: '200'
      },
      '&:lang(ar)': {
        float: 'left'
      },
    },
    '& $alertContainer': {
      ...mixins.boxSizing(),
      padding: '15px 10px 0',
      '& $alertContent': {
        background: '#fae0e0',
        ...mixins.boxShadow('0 2px 4px 0 rgba(0, 0, 0, 0.07)'),
        padding: '12px 20px 7px',
        '& $alertTitle': {
          marginBottom: '3px',
          fontWeight: 'bold',
          display: 'block',
          fontSize: '16px',
          '@media(min-width:901px)': {
            fontSize: '20px'
          }
        },
        '& $alertButtonContainer': {
          display: 'table',
          width: '100%',
          paddingTop: '3px',
          '& $alertButton': {
            display: 'table-cell',
            verticalAlign: 'middle',
            border: 'solid 1px #d0021b',
            backgroundColor: '#fff',
            height: '35px',
            minWidth: '48px',
            textTransform: 'uppercase',
            margin: '0 10px 7px 0',
            cursor: 'pointer',
            '&:hover': {
              background: '#d0021b',
              color: '#fff',
              ...mixins.transitionAll()
            }
          },
          '@media(min-width:901px)': {
            paddingTop: '13px'
          }
        },
        '@media(min-width:901px)': {
          padding: '20px 30px 10px'
        }
      },
      '@media(min-width:901px)': {
        padding: '30px 20px 0 10px',
        maxWidth: '1190px',
        margin: '0 auto'
      }
    }
  }
};
